import styled from "@emotion/styled";
import { sizes, stack } from "@ui/style";

export const Page = styled.div`
	${stack(undefined, "flexstart", "stretch")}
	flex-grow: 1;
	margin: 0 auto;
	max-width: calc(100vw - 40px);
	padding-bottom: ${sizes.M};
`;
